module.exports = __webpack_public_path__ + "img/0047.9226799e.jpg";